import { StyleSheet } from 'react-native'
import { color, fontFamily } from '../../../../../theme'

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: color.palette.cream,
    paddingTop: 10,
    paddingHorizontal: 16
  },
  observerText: {
    color: color.palette.smokyBlack,
    fontFamily: fontFamily.GTAmericaExtended,
    letterSpacing: 1,
    fontSize: 12,
    marginBottom: 16,
    alignSelf: 'center'
  }
})
